import type { Components, createTheme } from '@mui/material';

const menuItem: Components<ReturnType<typeof createTheme>>['MuiMenuItem'] = {
  styleOverrides: {
    root: ({ theme: { typography } }) => ({
      ...typography.body1,
    }),
  },
};

export { menuItem };
